import { render, staticRenderFns } from "./1_privacyPolicy.vue?vue&type=template&id=5b66ceaf&scoped=true&"
import script from "./1_privacyPolicy.vue?vue&type=script&lang=js&"
export * from "./1_privacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./1_privacyPolicy.vue?vue&type=style&index=0&id=5b66ceaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66ceaf",
  null
  
)

export default component.exports